import * as yup from 'yup';

export const jvmMemoryOptimizationValidationSchema = yup.boolean().required();
